<template>
  <div class="main">
    <section class="panel panel-default">
      <header class="panel-heading">
        <h4 class="panel-title">{{ pageTitle }}考核表</h4>
      </header>
      <div class="panel-body" v-if="loaded">

        <!-- ── 幹部資訊 ── -->
        <div class="table-responsive" style="margin-bottom: 20px;">
          <table class="table table-bordered mb-none" style="background: #f9f9f9;">
            <tbody>
              <tr>
                <th class="text-center" style="width:12%">學號</th>
                <td style="width:13%">{{ detail.stuAccount }}</td>
                <th class="text-center" style="width:12%">姓名</th>
                <td style="width:13%">{{ detail.stuName }}</td>
                <th class="text-center" style="width:12%">科系</th>
                <td style="width:13%">{{ detail.deptStr }}</td>
                <th class="text-center" style="width:12%">年級</th>
                <td style="width:13%">{{ detail.grade }}</td>
              </tr>
              <tr>
                <th class="text-center">班級</th>
                <td>{{ detail.dradeClass }}</td>
                <th class="text-center">負責區域</th>
                <td>{{ detail.mageArea }}</td>
                <th class="text-center">請假次數</th>
                <td>{{ detail.leaveCount }}</td>
                <th class="text-center">記點點數</th>
                <td>{{ detail.levsPoints }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ── 四個面向（幹部填寫具體事實 + 評分者填得分）── -->
        <div v-for="dim in dimensions" :key="dim.key">
          <h5>{{ dim.title }}(配分：{{ dim.weight }}%)</h5>

          <div v-for="(q, qi) in dim.questions" :key="qi" class="row" style="margin-bottom: 12px; align-items: flex-start;">
            <div class="col-md-3" style="padding-top: 6px;">
              <span style="color: red; margin-right: 2px;">*</span>{{ q }}
            </div>
            <div class="col-md-9">
              <textarea
                class="form-control"
                rows="3"
                placeholder="請填寫具體事實"
                v-model="selfForm.answers[dim.key][qi]"
                :disabled="!detail.canEditSelf"
              ></textarea>
            </div>
          </div>

          <!-- 得分（評分者填）-->
          <div class="row form-group" style="margin-top: 8px;">
            <div class="col-md-1" style="padding-top: 7px;"><label>得分</label></div>
            <div class="col-md-2">
              <template v-if="showDimensionScores">
                <input type="number" step="0.01" class="form-control" v-model.number="scoreForm[dim.scoreField]" />
              </template>
              <template v-else-if="detail.myScore && detail.myScore[dim.scoreField]">
                <input type="number" class="form-control" :value="detail.myScore[dim.scoreField]" disabled />
              </template>
              <template v-else>
                <input type="number" class="form-control" disabled />
              </template>
            </div>
          </div>

          <hr />
        </div>

        <!-- ── 環境說明（幹部與評分者共用）── -->
        <div class="row form-group">
          <div class="col-md-12">
            <label><strong>環境說明</strong>（特殊環境或補充背景，幹部及評分者皆可修改）</label>
            <textarea class="form-control" rows="4" v-model="environmentNote" :disabled="!detail.canEditEnvironmentNote"></textarea>
          </div>
        </div>

        <!-- ── 同學補充說明 ── -->
        <div class="row form-group">
          <div class="col-md-12">
            <label><strong>補充說明</strong>（如有上面未說明事項，可條列式說明）</label>
            <textarea class="form-control" rows="4" v-model="selfForm.selfNote" :disabled="!detail.canEditSelf"></textarea>
          </div>
        </div>

        <!-- ── 幹部儲存按鈕 ── -->
        <div class="row form-group" v-if="detail.canEditSelf">
          <div class="col-md-12">
            <button class="btn btn-danger" @click="saveSelf('draft')">儲存草稿</button>
            <button class="btn btn-primary" style="margin-left: 6px;" @click="saveSelf('submitted')">送出</button>
          </div>
        </div>

        <hr />

        <!-- ── 評分者補充說明 + 分數欄位 ── -->
        <div v-if="detail.canScore || detail.myScore">
          <div class="row form-group">
            <div class="col-md-12">
              <label>評分補充說明</label>
              <textarea class="form-control" rows="3" v-model="scoreForm.comment" :disabled="!detail.canScore"></textarea>
            </div>
          </div>

          <div class="row form-group">
            <div class="col-md-4" v-if="showInterviewScoreInput || (detail.myScore && detail.smtr === '2' && detail.myRaterRole !== 'mage')">
              <label>*面試成績(40%)</label>
              <input type="number" step="0.01" class="form-control"
                v-model.number="scoreForm.interviewScore"
                :disabled="!showInterviewScoreInput" />
            </div>
            <div class="col-md-4" v-if="showAssessScoreDisplay">
              <label>{{ detail.smtr === '1' ? '考核成績(100%)' : '考核成績(60%)' }}（系統自動計算）</label>
              <input type="number" class="form-control" :value="displayAssessScore" disabled />
            </div>
          </div>

          <div class="row form-group" v-if="detail.canScore">
            <div class="col-md-12">
              <button class="btn btn-danger" @click="saveScore">儲存評分</button>
            </div>
          </div>
        </div>

        <hr />

        <!-- ── 管理員：所有評分人明細 ── -->
        <div class="row form-group" v-if="isAdmin('stay') && detail.allScores && detail.allScores.length">
          <div class="col-md-12">
            <h5>所有評分人明細</h5>
            <div class="table-responsive">
              <table class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center">評分人</th>
                    <th class="text-center">身份</th>
                    <th class="text-center">工作態度</th>
                    <th class="text-center">工作能力</th>
                    <th class="text-center">工作績效</th>
                    <th class="text-center">溝通協調</th>
                    <th class="text-center" v-if="detail.smtr === '2'">面試成績</th>
                    <th class="text-center">考核成績</th>
                    <th class="text-center">補充說明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in detail.allScores" :key="index">
                    <td class="text-center">{{ item.raterName || item.raterAccount }}</td>
                    <td class="text-center">{{ item.roleDisplay }}</td>
                    <td class="text-center">{{ item.attitudeScore != null ? item.attitudeScore : '—' }}</td>
                    <td class="text-center">{{ item.abilityScore != null ? item.abilityScore : '—' }}</td>
                    <td class="text-center">{{ item.performanceScore != null ? item.performanceScore : '—' }}</td>
                    <td class="text-center">{{ item.communicationScore != null ? item.communicationScore : '—' }}</td>
                    <td class="text-center" v-if="detail.smtr === '2'">
                      {{ item.interviewScore != null ? item.interviewScore : '—' }}
                    </td>
                    <td class="text-center">{{ item.assessScore != null ? item.assessScore : '—' }}</td>
                    <td class="text-center">{{ item.comment }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- ── 總評 ── -->
        <div class="row form-group">
          <div class="col-md-12">
            <h5>總評</h5>
            <table class="table table-bordered mb-none" style="max-width: 450px;">
              <tbody>
                <tr v-if="detail.smtr === '2'">
                  <th style="width: 50%">面試成績(40%)</th>
                  <td>{{ detail.avgInterviewScore != null ? detail.avgInterviewScore : '—' }}</td>
                </tr>
                <tr>
                  <th>{{ detail.smtr === '2' ? '考核成績(60%)' : '考核成績(100%)' }}</th>
                  <td>{{ detail.avgAssessScore != null ? detail.avgAssessScore : '—' }}</td>
                </tr>
                <tr>
                  <th>總成績</th>
                  <td>{{ detail.avgTotalScore != null ? detail.avgTotalScore : '—' }}</td>
                </tr>
              </tbody>
            </table>
            <div style="margin-top: 8px; color: #888; font-size: 12px;">
              <template v-if="detail.smtr === '2' && detail.evaluateType === 'reserve'">
                備註：面試成績為輔導人員評分平均；考核成績由現任幹部四面向評分（態度30%＋能力20%＋績效20%＋溝通30%）自動計算後取平均。
              </template>
              <template v-else-if="detail.smtr === '2'">
                備註：考核成績由四面向（態度30%＋能力20%＋績效20%＋溝通30%）自動計算；總成績 = 面試平均×40% + 考核平均×60%，僅填面試者不列入考核平均。
              </template>
              <template v-else>
                備註：考核成績由四面向（態度30%＋能力20%＋績效20%＋溝通30%）自動計算，總成績 = 考核成績(100%)。
              </template>
            </div>
          </div>
        </div>

        <!-- ── 返回 ── -->
        <div class="row form-group">
          <div class="col-md-12">
            <button class="btn btn-default" @click="$router.back()">返回</button>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
const DIMENSIONS = [
  {
    key: 'attitude',
    title: '工作態度',
    weight: 30,
    scoreField: 'attitudeScore',
    questions: [
      '熱心參與宿舍事務並協助相關事宜?',
      '對宿舍活動是否熱心參與?',
      '對宿舍公共區域衛生及整潔是否盡心盡力?',
      '具有責任心，能徹底達成任務?'
    ]
  },
  {
    key: 'ability',
    title: '工作能力',
    weight: 20,
    scoreField: 'abilityScore',
    questions: [
      '具有策劃能力，工作能力求改善?',
      '工作效率高，具有卓越創意?',
      '工作不誤期，表現符合要求?',
      '處理宿舍事務是否公正無私?'
    ]
  },
  {
    key: 'performance',
    title: '工作績效',
    weight: 20,
    scoreField: 'performanceScore',
    questions: [
      '靈活分配工作，達成任務?',
      '對宿舍事務處理熟悉',
      '是否熟悉幹部職責?',
      '是否按規定時間點名及回報相關事務?',
      '點名單及相關表單是否按時填寫繳交?'
    ]
  },
  {
    key: 'communication',
    title: '溝通協調',
    weight: 30,
    scoreField: 'communicationScore',
    questions: [
      '與住宿同學相處或溝通時態度是否良好?',
      '善於上下溝通、平行協調，能自發與人合作?',
      '如遇宿舍工作有疑義時是否能進行溝通討論?'
    ]
  }
];

function initAnswers() {
  const a = {};
  DIMENSIONS.forEach(d => {
    a[d.key] = d.questions.map(() => '');
  });
  return a;
}

export default {
  data() {
    return {
      loaded: false,
      detail: {},
      dimensions: DIMENSIONS,
      selfForm: {
        answers: initAnswers(),
        selfNote: ''
      },
      environmentNote: '',
      scoreForm: {
        attitudeScore: null,
        abilityScore: null,
        performanceScore: null,
        communicationScore: null,
        interviewScore: null,
        comment: ''
      }
    };
  },
  computed: {
    pageTitle() {
      return this.detail.evaluateType === 'current' ? '現任幹部' : '儲備幹部';
    },
    isReserveSmtr2() {
      return this.detail.evaluateType === 'reserve' && this.detail.smtr === '2';
    },
    // 顯示四個面向得分欄：儲備第二學期只有現任幹部（mage）評考核需填四面向
    showDimensionScores() {
      if (!this.detail.canScore) return false;
      if (this.isReserveSmtr2) return this.detail.myRaterRole === 'mage';
      return true;
    },
    showInterviewScoreInput() {
      if (!this.detail.canScore) return false;
      if (this.detail.smtr !== '2') return false;
      if (this.isReserveSmtr2 && this.detail.myRaterRole === 'mage') return false;
      return true;
    },
    // 考核成績由四面向即時計算（態度30%＋能力20%＋績效20%＋溝通30%），四面向未填齊回傳 null
    autoAssessScore() {
      const vals = [
        this.scoreForm.attitudeScore, this.scoreForm.abilityScore,
        this.scoreForm.performanceScore, this.scoreForm.communicationScore
      ].map(v => (v === '' || v == null ? null : Number(v)));
      if (vals.some(v => v == null || isNaN(v))) return null;
      return Math.round((vals[0] * 0.3 + vals[1] * 0.2 + vals[2] * 0.2 + vals[3] * 0.3) * 100) / 100;
    },
    showAssessScoreDisplay() {
      if (this.showDimensionScores) return true;
      return !!(this.detail.myScore && this.detail.myScore.assessScore != null);
    },
    displayAssessScore() {
      if (this.showDimensionScores) return this.autoAssessScore;
      return this.detail.myScore ? this.detail.myScore.assessScore : null;
    }
  },
  mounted() {
    const stored = this.getStore(this.$route.name);
    const param = stored ? JSON.parse(stored) : this.$route.params;
    if (!param || !param.schYear) {
      this.$router.back();
      return;
    }
    this.detail = {
      schYear: param.schYear,
      smtr: param.smtr,
      evaluateType: param.evaluateType,
      stuAccount: param.stuAccount
    };
    this.loadDetail();
  },
  methods: {
    loadDetail() {
      const { schYear, smtr, evaluateType, stuAccount } = this.detail;
      this.$axios.get(`/api/CadreAssess/detail/${schYear}/${smtr}/${evaluateType}/${stuAccount}`).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '讀取失敗', () => this.$router.back());
          return;
        }
        const d = resp.data.data;
        this.detail = d;
        this.environmentNote = d.environmentNote || '';
        this.selfForm.selfNote = d.selfNote || '';

        // 解析 selfFormJson → 填入各面向答案
        const answers = initAnswers();
        if (d.selfFormJson) {
          try {
            const parsed = JSON.parse(d.selfFormJson);
            if (parsed && typeof parsed === 'object') {
              DIMENSIONS.forEach(dim => {
                if (Array.isArray(parsed[dim.key])) {
                  parsed[dim.key].forEach((v, i) => {
                    if (i < answers[dim.key].length) answers[dim.key][i] = v || '';
                  });
                }
              });
            }
          } catch (e) { /* ignore */ }
        }
        this.selfForm.answers = answers;

        if (d.myScore) {
          this.scoreForm = {
            attitudeScore: d.myScore.attitudeScore != null ? d.myScore.attitudeScore : null,
            abilityScore: d.myScore.abilityScore != null ? d.myScore.abilityScore : null,
            performanceScore: d.myScore.performanceScore != null ? d.myScore.performanceScore : null,
            communicationScore: d.myScore.communicationScore != null ? d.myScore.communicationScore : null,
            interviewScore: d.myScore.interviewScore != null ? d.myScore.interviewScore : null,
            comment: d.myScore.comment || ''
          };
        }
        this.loaded = true;
      });
    },
    saveSelf(status) {
      // 送出時，四個面向的每一題具體事實皆為必填
      if (status === 'submitted') {
        for (const dim of DIMENSIONS) {
          const ans = this.selfForm.answers[dim.key] || [];
          for (let i = 0; i < dim.questions.length; i++) {
            if (!ans[i] || !String(ans[i]).trim()) {
              bootbox.alert(`「${dim.title}」第 ${i + 1} 項尚未填寫：${dim.questions[i]}`);
              return;
            }
          }
        }
      }
      const payload = {
        schYear: this.detail.schYear,
        smtr: this.detail.smtr,
        evaluateType: this.detail.evaluateType,
        contentJson: JSON.stringify(this.selfForm.answers),
        selfNote: this.selfForm.selfNote,
        submitStatus: status
      };
      this.$axios.post('/api/CadreAssess/saveSelfForm', JSON.stringify(payload)).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '儲存失敗');
          return;
        }
        this.saveEnvironmentNote(() => {
          bootbox.alert(resp.data.msg || '儲存成功', () => this.loadDetail());
        });
      });
    },
    saveEnvironmentNote(cb) {
      if (!this.detail.canEditEnvironmentNote) {
        if (cb) cb();
        return;
      }
      const payload = {
        schYear: this.detail.schYear,
        smtr: this.detail.smtr,
        evaluateType: this.detail.evaluateType,
        stuAccount: this.detail.stuAccount,
        environmentNote: this.environmentNote
      };
      this.$axios.post('/api/CadreAssess/saveEnvironmentNote', JSON.stringify(payload)).then(resp => {
        if (cb) cb();
        else bootbox.alert(resp.data.msg || (resp.data.status === 'success' ? '儲存成功' : '儲存失敗'));
      });
    },
    saveScore() {
      // 前端檢核與後端一致：四面向全填或全空；依情境檢查必填（後端為最終防線）
      const norm = v => (v === '' || v == null ? null : v);
      const dims = [
        norm(this.scoreForm.attitudeScore), norm(this.scoreForm.abilityScore),
        norm(this.scoreForm.performanceScore), norm(this.scoreForm.communicationScore)
      ];
      const filled = dims.filter(v => v != null).length;
      if (this.showDimensionScores) {
        if (filled > 0 && filled < 4) { bootbox.alert('四個面向得分需全部填寫或全部留空'); return; }
        const dimsRequired = this.detail.smtr === '1' || (this.isReserveSmtr2 && this.detail.myRaterRole === 'mage');
        if (dimsRequired && filled < 4) { bootbox.alert('請填寫四個面向得分'); return; }
      }
      if (this.showInterviewScoreInput && norm(this.scoreForm.interviewScore) == null) {
        bootbox.alert('請填入面試分數'); return;
      }
      const payload = {
        schYear: this.detail.schYear,
        smtr: this.detail.smtr,
        evaluateType: this.detail.evaluateType,
        stuAccount: this.detail.stuAccount,
        attitudeScore: dims[0],
        abilityScore: dims[1],
        performanceScore: dims[2],
        communicationScore: dims[3],
        interviewScore: norm(this.scoreForm.interviewScore),
        comment: this.scoreForm.comment
      };
      this.$axios.post('/api/CadreAssess/upsertScore', JSON.stringify(payload)).then(resp => {
        if (resp.data.status !== 'success') {
          bootbox.alert(resp.data.msg || '儲存失敗');
          return;
        }
        this.saveEnvironmentNote(() => {
          bootbox.alert(resp.data.msg || '儲存成功', () => this.loadDetail());
        });
      });
    }
  }
};
</script>
